<template>
  <div class="height-100">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "PointIndex"
}
</script>

<style scoped>

</style>
